import React, { useEffect } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import * as R from 'ramda';
import { useDispatch } from 'react-redux';
import { fetchServices } from '../../../../../actions/services-api';
import ServiceInfo from '../../../../../constants/models/serviceInfo';

export const SearchService = ({ connectionType, searchPage, setSearchPage, searchFilter, setSearchFilter, setCurrentPage, updateLoadedItems, setLoadMore }) => {
    const dispatch = useDispatch();
    let selectSearch = '';

    const sleep = ms =>
        new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, ms);
        });

    async function searchAreEqual(search) {
        await sleep(1000);
        return search === selectSearch;
    }



    async function loadOptions(search, loadedOptions, { page }) {
        let response = [];
        let responseJSON = [];
        let hasMore = false;
        if (search === '' || R.isNil(search) ) {
            response = await dispatch(fetchServices(connectionType, page));
            responseJSON = response.items.map(e => new ServiceInfo(e));
            hasMore = responseJSON.length === 100;
        }
        else if ((search !== '' && !R.isNil(search))) {
            let areEqual = await searchAreEqual(search);
            if (areEqual) {
                response = await dispatch(fetchServices(connectionType, selectSearch !== search ? 0 : searchPage, search));
                responseJSON = response.items.map(e => new ServiceInfo(e));
                if (responseJSON.length === 100) {
                    setSearchPage(searchPage + 1);
                    hasMore = true;
                }
                else {
                    hasMore = false;
                }
            }
            else {
                hasMore = true;
            }
        }
        updateLoadedItems(response);
        let filteredOptions = responseJSON.filter(s => s.branches.length > 0).length > 0 && responseJSON.filter(s => s.branches.length > 0).map(sr =>
            sr.branches.map(s => {
                let city = !R.isNil(s.address.addressLocality) && s.address.addressLocality !== '' ? s.address.addressLocality[0].toUpperCase() + s.address.addressLocality.toLowerCase().slice(1) : '';
                let val = s.name + (city !== '' ? ' (' + (!R.isNil(s.address.postalCode) ? s.address.postalCode + ' ' : '') + city + ')' : '');
                return {
                    label: val,
                    value: val
                };
            }));
        filteredOptions = !R.isNil(filteredOptions) && filteredOptions.length > 0 ? [].concat.apply([], filteredOptions) : [];

        if ((R.isNil(search) || search === '') && !R.isNil(page)) {
            setCurrentPage((parseInt(page) + 1));
        }
        if ((R.isNil(search) || search === '') && response.length === 100) {
            setLoadMore(true);
        }
        else if ((R.isNil(search) || search === '') && response.length < 100) {
            setLoadMore(false);
        }
        return {
            options: filteredOptions,
            hasMore: hasMore,
            additional: {
                page: !R.isNil(search) && search !== '' ? searchPage : page + 1,
            }
        };
    }

    useEffect(() => {
        loadOptions("", null, 0);
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionType]);

    return (
        <AsyncPaginate id={"search-" + connectionType} className="form-control form-select bg-dim rounded-max border-none no-focus shadow-none"
            value={searchFilter}
            loadOptions={loadOptions}
            onChange={(option) => { setSearchFilter(option.map(o => { return { label: o.value, value: o.value }; })); }}
            isMulti={true}
            cacheUniqs={[connectionType]}
            additional={{ page: 0 }}
            onInputChange={(searchInput) => {
                selectSearch = searchInput;
                if (!searchInput.includes(selectSearch)) {
                    setSearchPage(0);
                }
            }}
            placeholder="Rechercher..."
            loadingMessage={() => "Chargement..."}
            noOptionsMessage={() => "Aucun résultat"}

        />
    );
};